'use es6';

import keyMirror from 'react-utils/keyMirror';
import { createAction } from 'flux-actions';
export const AccountsActionTypes = keyMirror({
  FILTER_ACCOUNTS: null
});
export const filterAccounts = createAction(AccountsActionTypes.FILTER_ACCOUNTS, filter => ({
  filter
}));